// Module
var code = `<template class="global-linear-progress">
  <require from="./global-linear-progress.scss"></require>
  <mdc-card>
    <mdc-linear-progress open progress.bind="progress" buffer.bind="progress">
    </mdc-linear-progress>
  </mdc-card>
</template>
`;
// Exports
export default code;